import React from "react";
import "./styles.scss";
import menuSvg from "../../../icons/menu.svg";
import logoYWLarge from "../../../icons/LuxYW-name.svg";
import logoYW from "../../../icons/LuxYW-logo.svg";
import NavToggleMenu  from "../NavToggleMenu/NavToggleMenu";

import {PortalHeaderProps} from "./props";
import {useHeaderMenuSearch, useLanguageCurrencyPicker} from "./hooks/headerHooks";
import LanguageCurrencyFullScreen
  from "../LanguageCurrencyPicker/components/LanguageCurrencyFullScreen/LanguageCurrencyFullScreen";
import Picker from "../LanguageCurrencyPicker/components/Picker/Picker";
import {HeaderEndElement} from "./components/HeaderEndElement";
import {FocusableTypeAhead} from "./components/FocusableTypeAhead";

function PortalHeader({
  menuHeaderTitle,
  portalLogoLink,
  portalLogoSmall,
  portalLogoSmallAlt,
  portalLogoLarge,
  portalLogoLargeAlt,
  desktopEndContainer,
  navigationLinks,
  languageCurrencyPicker,
  onMenuClick,
  onCurrencyPickerClick,
  searchBox,
  menuIcon = menuSvg
}: PortalHeaderProps) {
  const {
    domRefs,
    headerSearchHandlers,
    focusedSearch,
    searchBoxProps
  } = useHeaderMenuSearch(onMenuClick, searchBox, '');
  const {headerCenterRef, focusableRef, navMenuRef} = domRefs;
  const {handleMenuClick, handleOverlayClick, onCloseMenu, onClickInput, onInputKeyUp, onInputKeyDown, doSearchChange} = headerSearchHandlers;
  const {fullScreenRef, handleButtonClick, handleFullScreenClick, toggleProps} = useLanguageCurrencyPicker(languageCurrencyPicker, onCurrencyPickerClick);
  const { minCharacters, options, bgPlaceholder, placeholder, notFoundText, hideSuggestions, search } = searchBoxProps;

  return (
    <>
      <NavToggleMenu
        ref={navMenuRef}
        headerTitle={menuHeaderTitle}
        navigationLinks={navigationLinks || []}
        languageCurrencyToggle={toggleProps}
        onLanguageCurrencyFullScreenClick={handleFullScreenClick}
        handleOverlayClick={handleOverlayClick}
        onCloseMenu={onCloseMenu} />
      <LanguageCurrencyFullScreen
        ref={fullScreenRef}
        headerTitle={languageCurrencyPicker?.title || ''}>
        <Picker
          items={languageCurrencyPicker?.items}
          buttonOnClick={handleButtonClick}
          buttonText={languageCurrencyPicker?.buttonText || ''}
          title={languageCurrencyPicker?.title || ''}
          hideCurrency={languageCurrencyPicker?.hideCurrency || false}
      />
      </LanguageCurrencyFullScreen>
      <div className="portal-header" data-e2e="portal-header">
        <div className={`portal-header__container`}>
          <button className="portal-header__menu-button" onClick={handleMenuClick} type="button">
            <img src={menuIcon} alt="Menu Icon" />
          </button>
          <div className="portal-header__logo">
            <a href={portalLogoLink || "#"} className='portal-header__logo-link' >
              <img
                className='portal-header__logo--small'
                src={portalLogoSmall || logoYW}
                alt={portalLogoSmallAlt || "Portal Link"} />
                <img
                className='portal-header__logo--large'
                src={portalLogoLarge || logoYWLarge}
                alt={portalLogoLargeAlt || "Portal Link"} />
            </a>
          </div>
          <div className="portal-header__container-search" ref={headerCenterRef}>
            <FocusableTypeAhead
              minCharacters={minCharacters}
              options={options}
              search={search}
              bgPlaceholder={bgPlaceholder}
              placeholder={placeholder}
              notFoundText={notFoundText}
              hideSuggestions={hideSuggestions}
              focus={focusedSearch}
              onSearchChange={doSearchChange}              
              selectorClass="empty-box__container"
              focusableRef={focusableRef}
              onClickInput={onClickInput}
              onInputKeyDown={onInputKeyDown}
              onInputKeyUp={onInputKeyUp}
            />
          </div>
          <div className='portal-header__container-desktop-end'>
            <HeaderEndElement desktopEndContainer={desktopEndContainer} />
          </div>
          </div>
        </div>
    </>
  );
}

export default React.memo(PortalHeader);
